import { render, staticRenderFns } from "./redConstructionDetail.vue?vue&type=template&id=3d334aee&scoped=true&"
import script from "./redConstructionDetail.vue?vue&type=script&lang=js&"
export * from "./redConstructionDetail.vue?vue&type=script&lang=js&"
import style0 from "./redConstructionDetail.vue?vue&type=style&index=0&id=3d334aee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d334aee",
  null
  
)

export default component.exports